
import { TABLE_FETCH,TABLE_UPDATE,TABLE_SEARCH } from "../constants/tableConstants";

const tableReducer = (state={data:[]},action)=>{
        let newData;
        switch(action?.type) {

               case TABLE_FETCH:

                  return {
                    ...state,
                    data:[...action.payload]
                  };

               case TABLE_UPDATE:
                 
                  newData = state.data.map(r=>r.uuid === action.payload.uuid ? action.payload : r);

                  return {
                    ...state,
                    data:[...newData]
                  };

               case TABLE_SEARCH:
                 
                  newData = state.data.map(
                      r=>r.uuid === action.payload.uuid 
                      ? { ...r,selected:true}
                      : r
                   );

                  return {
                    ...state,
                    data:[...newData]
                  };
            
               default:
                  return state;
        }

       
};

export default tableReducer;